module.exports = __webpack_public_path__ + "static/media/followers.1433d33d.svg";